import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {UIRouterGlobals} from '@uirouter/angular';
import {StateService} from "@uirouter/core";
import {Subscription} from "rxjs";

import {
    AccountModulesService,
    AuthenticationService,
    DatabaseService,
    MenuService,
    ParametersService,
    SettingsService,
    SettingsAccountService,
    SubtitlesService,
    TilesService,
    UpdateService,
    ViewsService,
    ZonesService, StatisticsTempService,
} from "../core";
import {MenuElement, MenuType} from "../models";

@Component({
    selector: 'top-menu',
    templateUrl: './top-menu.component.html',
    styleUrls: ['./top-menu.component.scss']
})
export class TopMenuComponent implements OnInit, OnDestroy {
    windowHeight: number = 0;
    showModulesList: boolean = false;
    mainMenuArray: [string, MenuElement[]][] | null = null;
    private updatedMenuSubscription: Subscription | undefined;

    constructor(
        private accountModules: AccountModulesService,
        public authentication: AuthenticationService,
        private database: DatabaseService,
        private location: Location,
        public menu: MenuService,
        public parameters: ParametersService,
        private settings: SettingsService,
        private settingsAccount: SettingsAccountService,
        public $state: StateService,
        private statisticsTemp: StatisticsTempService,
        public subtitles: SubtitlesService,
        private tiles: TilesService,
        public uiRouterGlobals: UIRouterGlobals,
        private update: UpdateService,
        private views: ViewsService,
        private zones: ZonesService,
    ) {
    }

    ngOnInit() {
        this.windowHeight = window.innerHeight;
        this.updateMainMenuArray();
        this.updatedMenuSubscription = this.menu.updatedMenu.subscribe(() => this.updateMainMenuArray());
    }

    ngOnDestroy() {
        this.updatedMenuSubscription?.unsubscribe();
    }

    @HostListener('window:resize', ['$event'])
    onResize(_event: Event) {
        this.windowHeight = window.innerHeight;
    }

    clickOutside(): void {
        this.showModulesList = false;
    }

    setIconUrl(element: MenuType): string {
        return this.views.setIconUrl(element);
    }

    subtitle(id: number): string {
        return this.subtitles.setSubtitle(id);
    }

    selectModule(index: number, style: string): void {
        if (index !== this.parameters.selectedModuleIndex && index !== -1) {
            this.database.resetDatabaseService();
            if (this.parameters.selectedModuleType !== 'zones_controller') {
                this.tiles.withoutContainer.elements = [];
                this.tiles.container = {};
            } else {
                this.zones.setTemplate('zones');
                this.zones.controlTemplate = 'mode_select';
            }
            this.menu.allElementMenu = {};
            this.menu.showInputPassword(false);
        }
        this.menu.showWiki(0);
        this.menu.menuPromise = undefined;
        this.accountModules.selectModule(index, style);
        this.showModulesList = false;
        this.menu.showDropdownMenu = false;
        this.statisticsTemp.clearColumnsOccurrence();
    }

    showModuleListFunction(): void {
        this.showModulesList = !this.showModulesList;
    }

    homeScreen(): void {
        this.menu.showDropdownMenu = false;

        if (this.location.path().includes('home')) {
            return;
        }

        this.$state.go('home', {selectedModuleHash: this.parameters.selectedModuleHash});

        this.menu.clearMenu();
        this.update.stopInterval();

        if (this.parameters.selectedModuleHash !== 0) {
            this.update.updateData();
        }
        this.update.startInterval();

        if (this.parameters.selectedModuleType === 'zones_controller') {
            this.zones.setTemplate('zones');
            this.zones.controlTemplate = 'mode_select';
        }
    }

    zonesSettingsScreen(): void {
        if (this.parameters.selectedModule.moduleStatus && this.parameters.selectedModule.controllerStatus) {
            this.menu.clearMenu();
            this.menu.showDropdownMenu = false;
            // $window.location.href = `${API_URL}/web/${parameters.selectedModuleHash}/zones_settings`; // Nx server
            this.$state.go('zones_settings', {selectedModuleHash: this.parameters.selectedModuleHash});
        }
    }

    alarmHistoryScreen(): void {
        this.menu.clearMenu();
        this.menu.showDropdownMenu = false;
        this.$state.go('alarm_history', {selectedModuleHash: this.parameters.selectedModuleHash});
        this.update.stopInterval();
    }

    statisticsScreen(): void {
        this.menu.clearMenu();
        this.menu.showDropdownMenu = false;
        this.$state.go('statistics', {selectedModuleHash: this.parameters.selectedModuleHash});
        this.update.stopInterval();
    }

    settingsScreen(): void {
        this.menu.clearMenu();
        this.settingsAccount.getAccountInformation();
        this.settings.setModulesInformation();
        this.menu.showDropdownMenu = false;
        this.$state.go('settings.account', {selectedModuleHash: this.parameters.selectedModuleHash});
        this.update.stopInterval();
    }


    isSettingsSelected(): boolean {
        return this.uiRouterGlobals.current.name.includes('settings') && this.uiRouterGlobals.current.name !== 'zones_settings';
    }

    showDropdownMenuFunction(): void {
        this.menu.showDropdownMenu = !this.menu.showDropdownMenu;
    }

    getMainMenuAsArray(): [string, MenuElement[]][] {
        if (this.mainMenuArray === null && this.menu.downloaded) {
            this.updateMainMenuArray();
        }
        return this.mainMenuArray ?? [];
    }

    private updateMainMenuArray(): void {
        this.mainMenuArray = this.menu.downloaded ? Object.entries(this.menu.mainMenu) : null;
    }

    hasZones(): boolean {
        if (this.parameters.selectedModuleType !== 'zones_controller'
            && this.parameters.selectedModuleType !== 'zones_system_controller') {
            return false;
        }
        const zonesData = this.database.zones.getValue();
        if (!this.database.isZonesDataType(zonesData)) {
            return false;
        }
        if (zonesData.elements.length === 0) {
            return false;
        }
        return zonesData.elements.some(zone => zone.zone.visibility);
    }
}
